import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { Button, Stack } from 'components';
import { useAiScribeContext } from 'modules/aiScribe/context/useAiScribe';
import {
  formatDuration,
  MicrophoneIcon,
  PauseIcon
} from 'modules/aiScribe/drawer/expanded/expanded';

import style from './recordingScreen.module.scss';

const RecordingScreen = () => {
  const {
    isPaused,
    duration,
    canvasRef,
    stopRecording,
    pauseRecording,
    resumeRecording,
    error,
    isSubmitting
  } = useAiScribeContext();

  return (
    <Stack height="100%" width="100%" className={style.recordingScreen}>
      <h2 className={style.title}>AI Scribe</h2>
      <Stack
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        boxSizing="border-box"
      >
        <Stack width="100%" display="flex" gap="2px" flexDirection="row" alignItems="center">
          <div className={clsx(style.canvasWrapper, isPaused && style.paused)}>
            <canvas
              ref={canvasRef}
              style={{
                width: '100%',
                height: '187px'
              }}
            />
          </div>
          <div className={style.line} />
        </Stack>
        <Stack
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          flexGrow={1}
        >
          <Stack display="flex" flexDirection="column" alignItems="center" gap="32px">
            <div className={style.duration}>{formatDuration(duration)}</div>
            <Stack width="176px">
              {isPaused ? (
                <Button
                  handleOnClick={resumeRecording}
                  text="Resume"
                  icon={
                    <Stack mr="4px">
                      <MicrophoneIcon />
                    </Stack>
                  }
                  theme="green"
                  size="large"
                />
              ) : (
                <Button
                  handleOnClick={pauseRecording}
                  text="Pause"
                  icon={
                    <Stack mr="4px">
                      <PauseIcon />
                    </Stack>
                  }
                  theme="warning"
                  size="large"
                />
              )}
            </Stack>
          </Stack>
          <Stack width="121px">
            {isPaused && (
              <Button
                customStyleClass={style.submitButton}
                disabled={!!error || isSubmitting}
                text="Submit"
                theme="borderless"
                size="small"
                handleOnClick={() => stopRecording()}
              />
            )}
          </Stack>
        </Stack>
        <AnimatePresence>
          {error && (
            <motion.div
              className={style.error}
              initial={{ opacity: 0, y: 100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 100 }}
            >
              <span className="material-icons">error_outline</span>
              <p>{error}</p>
            </motion.div>
          )}
        </AnimatePresence>
      </Stack>
    </Stack>
  );
};

export default RecordingScreen;
